<footer id="footer">
  <app-footer-center></app-footer-center>
  <div class="footer-block">
    <div class="footer-container">
      @for( item of footerData;track item;let i = $index){
      @if (isMobile()) {
      <div class="footer-accordion">
        <div class="accordion-item" [class.open]="isAccordionOpen()[i]">
          <div class="accordion-header" tabindex="0" role="button" [attr.aria-expanded]="isAccordionOpen()[i]"
               (click)="toggleAccordion(i)" (keydown.enter)="toggleAccordion(i)" (keydown.space)="$event.preventDefault(); toggleAccordion(i)">
            <h3 class="footer-title">{{item.title}}<span class="arrow">
              @if(isAccordionOpen()[i]){
                <svg class="ml-2 align-middle" xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
                  <path d="M13 7L7 1L1 7" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            }@else{
              <svg class="ml-2 align-middle" xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
                <path d="M1 1L7 7L13 1" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            }
              </span>
            </h3>
          </div>
          <div class="accordion-content" [class.accordion-content-open]="isAccordionOpen()[i]">
            @for(data of item.items;track data){
            @if(data?.isDownload){
            <a tabindex="0" (click)="downloadpdf(data?.url)" (keydown.enter)="downloadpdf(data?.url)" (keydown.space)="$event.preventDefault(); downloadpdf(data?.url)" class="d-flex align-items-center justify-content-between"><span>{{data?.label}}</span> <span class="download-item-meta"><span class="download-extension-badge" *ngIf="getFileExtension(data?.url)">{{ getFileExtension(data?.url) }}</span><i class="sd sd-download-01 submenu-download-icon"></i></span></a>
            }@else if(data?.isRoutable){
            <a [routerLink]="data?.url">{{data?.label}}</a>
            }@else {
            <a [href]="data?.url" target="_blank">{{data?.label}}</a>
            }
            }
          </div>
        </div>
      </div>
      }
      @else {
      <div ngbDropdown>
        <div id="dropdownConfig" ngbDropdownToggle tabindex="0" role="button" [attr.aria-expanded]="isAccordionOpen()[i]" class="text-white cursor-pointer" (click)="toggleAccordion(i)"
             (keydown.enter)="$event.preventDefault(); $event.target.click()" (keydown.space)="$event.preventDefault(); $event.target.click()">{{item.title}}
          <span class="arrow" >
            @if(isAccordionOpen()[i]){
              <svg class="m-bottom-negative" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M15 12.5L10 7.5L5 12.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
          }@else{
            <svg  xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none" class="ml-2">
              <path d="M1 1L7 7L13 1" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          }
          </span>
        </div>
        <div ngbDropdownMenu aria-labelledby="dropdownConfig" class="acc-content">
          @for(data of item.items;track data){
          @if(data?.isDownload){
          <a tabindex="0" ngbDropdownItem (click)="downloadpdf(data?.url)" (keydown.enter)="downloadpdf(data?.url)" (keydown.space)="$event.preventDefault(); downloadpdf(data?.url)" class="acc-content-item d-flex align-items-center justify-content-between"><span>{{data?.label}}</span> <span class="download-item-meta"><span class="download-extension-badge" *ngIf="getFileExtension(data?.url)">{{ getFileExtension(data?.url) }}</span><i class="sd sd-download-01 submenu-download-icon"></i></span></a>
          }@else if(data?.isRoutable){
          <a [routerLink]="data?.url" ngbDropdownItem class="acc-content-item">{{data?.label}}</a>
          }@else {
          <a [href]="data?.url" ngbDropdownItem target="_blank" class="acc-content-item">{{data?.label}}</a>
          }
          }
        </div>
      </div>

      }

      }
    </div>
  </div>

  <div class="footer-links-block">
    <div class="footer-links-container">
      <!-- "Follow Us" column hidden.
      <div class="footer-links-col">
        <h3 class="footer-col-title">Follow Us</h3>
        <div class="social-icons">
          <a href="https://www.facebook.com/248701808530454" target="_blank" rel="noopener noreferrer" class="social-icon" aria-label="Facebook"><i class="sd sd-fb"></i></a>
          <button type="button" class="social-icon" aria-label="LinkedIn"><i class="sd sd-linkedin"></i></button>
          <button type="button" class="social-icon" aria-label="X (Twitter)"><i class="sd sd-twitter-new-logo"></i></button>
          <button type="button" class="social-icon" aria-label="YouTube"><i class="sd sd-youtube-fill"></i></button>
        </div>
      </div>
      -->


      <div class="footer-links-col quick-links-col">
        <h3 class="footer-col-title">Quick Links</h3>
        <div class="quick-links-grid">
          <div class="quick-links-sub">
            <a routerLink="/about" title="Navigate to About Us page">About Us</a>
            <a href="https://support.nsdcindia.org/portal/en/signin" target="_blank" title="Opens NSDC Support Portal in a new tab">Help &amp; Support</a>
            <a routerLink="/terms-of-use" title="Navigate to Terms of Use page">Terms of use</a>
            <!-- <a routerLink="/release-history" title="Navigate to Release History page">Release History</a> -->
            <a routerLink="/sitemap" title="Navigate to Sitemap page">Sitemap</a>
          </div>
          <div class="quick-links-sub">
            <a routerLink="/contact-us" title="Navigate to Contact Us page">Contact Us</a>
            <a routerLink="/disclaimer" title="Navigate to Disclaimer page">Disclaimer</a>
            <a routerLink="/website-policy" title="Navigate to Website Policy page">Website Policy</a>
            <a routerLink="/wim" title="Navigate to Web Information Management page">Web Information Management</a>
          </div>
        </div>
      </div>

      <div class="footer-links-col external-links-col">
        <h3 class="footer-col-title">External Links</h3>
        <div class="external-links-grid">
          <a href="https://www.india.gov.in/" target="_blank" class="external-link-item" title="Opens National Portal of India website in a new tab">National Portal of India <i class="sd sd-link-external-02"></i></a>
          <a href="https://msde.gov.in" target="_blank" class="external-link-item" title="Opens Ministry of Skill Development and Entrepreneurship website in a new tab">MSDE <i class="sd sd-link-external-02"></i></a>
          <a href="https://mhrdnats.gov.in" target="_blank" class="external-link-item" title="Opens National Apprenticeship Training Scheme website in a new tab">NATS <i class="sd sd-link-external-02"></i></a>
          <a href="https://ncs.gov.in/" target="_blank" class="external-link-item" title="Opens National Career Service website in a new tab">NCS <i class="sd sd-link-external-02"></i></a>
          <a href="https://www.nsdcindia.org/products/sector-skill-council" target="_blank" class="external-link-item" title="Opens Sector Skill Council website in a new tab">SSC <i class="sd sd-link-external-02"></i></a>
          <a href="https://admin.skillindiadigital.gov.in/nosListing" target="_blank" class="external-link-item" title="Opens Standard NOS Listing website in a new tab">Standard NOS Listing <i class="sd sd-link-external-02"></i></a>
          <a href="https://pminternship.mca.gov.in" target="_blank" class="external-link-item" title="Opens PM Internship Scheme website in a new tab">PM Internship Scheme <i class="sd sd-link-external-02"></i></a>
          <a href="https://www.epfindia.gov.in" target="_blank" class="external-link-item" title="Opens Employees' Provident Fund Organisation website in a new tab">EPFO <i class="sd sd-link-external-02"></i></a>
          <a href="https://udyamregistration.gov.in" target="_blank" class="external-link-item" title="Opens Udyam Registration portal in a new tab">Udyam Portal <i class="sd sd-link-external-02"></i></a>
        </div>
      </div>
    </div>
  </div>

  <div class="footer-bottom-block">
    <div class="footer-item">
      © Copyright 2026 - All Rights Reserved
    </div>
    <div class="footer-meta-group">
      <div class="footer-item visitor-count-item" [title]="'Counting started since ' + (visitorCountStartDate | date:'d MMMM y')">
        <i class="sd sd-users-02"></i> Visitor Count: <strong>{{ visitorCount() }}</strong>
      </div>
      <div class="footer-item last-modified-item">
        <i class="sd sd-clock-fast-forward"></i> Last Updated On: <strong>{{ lastUpdatedOn | date:'d MMMM y' }}</strong>
      </div>
    </div>
  </div>

  <div class="footer-owned-by">
    Owned by Ministry of Skill Development and Entrepreneurship, Government of India
  </div>

</footer>
